import { render, staticRenderFns } from "./profile-badge.vue?vue&type=template&id=d2832ac4&scoped=true&"
import script from "./profile-badge.vue?vue&type=script&lang=ts&"
export * from "./profile-badge.vue?vue&type=script&lang=ts&"
import style0 from "./profile-badge.vue?vue&type=style&index=0&id=d2832ac4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2832ac4",
  null
  
)

export default component.exports